import React from "react";
import { twMerge } from "tailwind-merge";
import { Container } from "@ui";

interface SPSectionProps {
  children: React.ReactNode;
  headline: string;
  className?: string;
}

const SPSection = ({ children, headline, className }: SPSectionProps) => {
  return (
    <section className={twMerge("bg-lightBlue py-8 font-body", className)}>
      <Container className="flex flex-col max-w-[768px]">
        <h2 className="border-b-2 border-b-[#51B9AC] font-body text-2xl uppercase tracking-[0.96px] text-midnight lg:text-4xl lg:font-medium lg:tracking-[1.44px]">
          {headline}
        </h2>
        {children}
      </Container>
    </section>
  );
};

export default SPSection;
